import React from 'react';
import { TextInput, TextInputProps, StyleSheet, View, Text } from 'react-native';
import { useTheme } from '@/contexts/ThemeContext';

interface MoneyInputProps extends Omit<TextInputProps, 'onChangeText' | 'value'> {
  value: string;
  onChangeValue: (value: string) => void;
  prefix?: string;
}

export function MoneyInput({
  value,
  onChangeValue,
  prefix = 'R$',
  style,
  ...props
}: MoneyInputProps) {
  const { colors } = useTheme();

  const formatCurrency = (val: string) => {
    // Remove tudo que não é número
    const numericValue = val.replace(/\D/g, '');
    
    // Se estiver vazio, retorna vazio
    if (!numericValue) return '';

    // Converte para número e divide por 100 para ter os centavos
    const floatValue = parseFloat(numericValue) / 100;

    // Formata com 2 casas decimais e substitui ponto por vírgula
    return floatValue.toFixed(2).replace('.', ',');
  };

  const handleChangeText = (text: string) => {
    // Apenas formata e envia para o pai
    const formatted = formatCurrency(text);
    // Só dispara se o valor formatado for diferente do atual
    if (formatted !== value) {
      onChangeValue(formatted);
    }
  };

  return (
    <View style={[
      styles.container, 
      { 
        backgroundColor: colors.surface, 
        borderColor: colors.border,
      },
      style
    ]}>
      <Text style={[styles.prefix, { color: colors.textSecondary }]}>{prefix}</Text>
      <TextInput
        style={[styles.input, { color: colors.text }]}
        value={value}
        onChangeText={handleChangeText}
        keyboardType="number-pad"
        placeholder="0,00"
        placeholderTextColor={colors.textSecondary}
        {...props}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 56,
    borderWidth: 1,
    borderRadius: 12,
    paddingHorizontal: 16,
  },
  prefix: {
    fontSize: 16,
    fontFamily: 'Inter-Regular',
    marginRight: 8,
  },
  input: {
    flex: 1,
    height: '100%',
    fontSize: 16,
    fontFamily: 'Inter-Regular',
    borderWidth: 0, // Remove borda do input interno
    padding: 0, // Remove padding do input interno
  },
});
